import { useSelectState } from 'ariakit/select';

/**
 * Default initial value of the select.
 *
 *`defaultValue?: string | string[]`

 * The select value.
 * Use `value` and `setValue` props when working with form controlled components
 *
 *`value?: string | string[]`
 *
 * Sets the `value` state.
 *
 *`setValue?: function`
 *
 * Function that will be called when setting the select `value` state.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/select-alpha#usage)
 * - [Props](https://blockparty.endpoint.com/components/select-alpha#props)
 * <br />
 * @example
 * // Controlled example
 * const [value, setValue] = useState("");
 * useSelectStateAlpha({ value, setValue });
 * @example
 * // Externally controlled example
 * function MySelect({ value, onChange }) {
 *   const select = useSelectStateAlpha({ value, setValue: onChange });
 * }
 *
 */
/**
 *  @deprecated Please use Select for future implementation
 */
const useSelectStateAlpha = props => {
  const state = useSelectState({
    gutter: 8,
    sameWidth: true,
    ...props
  });
  return state;
};

export { useSelectStateAlpha };
